// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"281":"0339aa95","367":"f5f7de34","840":"db576671"}[chunkId] + ".css";
};